import { registerLazyNotificationRenderer } from "@/entities/notification"

registerLazyNotificationRenderer(
	"friend-found",
	() => import("../ui/friend-found-popup"),
)
registerLazyNotificationRenderer(
	"friend-not-found",
	() => import("../ui/friend-not-found-popup"),
)
registerLazyNotificationRenderer(
	"search-blocked-pending",
	() => import("../ui/search-blocked-pending-popup"),
)
registerLazyNotificationRenderer(
	"search-blocked-no-message",
	() => import("../ui/search-blocked-no-message-popup"),
)
registerLazyNotificationRenderer(
	"match-expired",
	() => import("../ui/match-expired-popup"),
)
